<template>
  <v-dialog width="700" v-model="dialog">
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <slot />
      </span>
    </template>
    <v-card>
      <v-card-title>
        Envios de {{ pacote.titulo }}
        <v-spacer />
        <v-btn icon @click="fechar()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-0">
        <v-list two-line>
          <template v-if="loading">
            <v-skeleton-loader type="list-item-two-line" />
            <v-skeleton-loader type="list-item-two-line" />
            <v-skeleton-loader type="list-item-two-line" />
            <v-skeleton-loader type="list-item-two-line" />
          </template>
          <template v-else-if="logs.length > 0">
            <v-list-item v-for="(log, i) in logs" :key="`log-${i}`">
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon class="mr-2">mdi-clock-outline</v-icon>
                  {{ hora(log.data_hora) }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <v-icon class="mr-2">mdi-account-outline</v-icon>
                  {{ log.usuario.login }} - {{ log.usuario.nome }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  Enviado para:
                  <v-chip
                    v-for="(email, j) in log.emails"
                    :key="`email-${i}-${j}`"
                    label
                    small
                    class="ml-2"
                  >
                    <v-icon left small>mdi-email</v-icon>{{ email }}
                  </v-chip>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn depressed @click="fechar()">FECHAR</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
export default {
  props: ["pacote"],
  data() {
    return {
      logs: [],
      loading: true,
      dialog: false,
    };
  },
  methods: {
    async carregar() {
      this.loading = true;
      try {
        this.logs = await this.$store.dispatch(
          "documento/logEnvioPacote",
          this.pacote.id
        );
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar o registro de envios do pacote",
        });
        this.fechar();
      }
      this.loading = false;
    },
    fechar() {
      this.logs = [];
      this.dialog = false;
      this.loading = true;
    },
    hora(hora) {
      const t = moment(hora);
      return t.format("DD/MM/YYYY") + " às " + t.format("hh:mm:ss");
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.carregar();
      }
    },
  },
};
</script>
